import type { FC } from 'react';
import { Chip as MuiChip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface IChipProps {
	color?: ChipProps['color'];
	children?: string;
	className?: string;
}

export const ChipStyled = styled(MuiChip)(({ theme }) => ({
	padding: '4px 8px',
	height: 'auto',

	'& .MuiChip-label': {
		...theme.typography.caption,
		lineHeight: '16px',
		fontWeight: 700,
		padding: 0,
	},

	'&.MuiChip-colorError': {
		color: theme.palette.neutral[0],
		backgroundColor: theme.palette.error.main,
	},

	'&.MuiChip-colorSecondary': {
		color: theme.palette.primary.dark,
		backgroundColor: theme.palette.secondary.main,
	},

	'&.MuiChip-colorWarning': {
		color: theme.palette.primary.dark,
		backgroundColor: theme.palette.warning.main,
	},
}));

export const ChipStyledV2 = styled(MuiChip)(({ theme }) => ({
	backgroundColor: theme.palette.neutral.main,
	boxShadow: theme.shadows[3],
	color: theme.palette.primary.main,
	border: `0.25px solid ${theme.palette.primary.light}`,

	'& .MuiChip-label': {
		...theme.typography.l1,
	},
}));

export const Chip: FC<IChipProps> = ({ className, children, color }) => {
	return <ChipStyled className={className} label={children} color={color} />;
};

export const ChipV2: FC<IChipProps> = ({ className, children }) => {
	return <ChipStyledV2 className={className} label={children} />;
};
